// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__lA9ZI","title":"InfoRow_title__3TzIl"};